import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import useWindowSize from "syf-component-library/ui/customHooks/useWindowWidth";
import { Inset } from "syf-component-library/ui/spacing";
import { CustomStatementImage } from "./subcomponents";
import endPoints from "../../../const/endpoints";
import icons from "../../../const/icons";
import { useConfig } from "../../../hooks/useConfig";
var EnrollmentLogo = function () {
    var windowWidth = useWindowSize();
    var assets = useConfig().hosts.assets;
    var enrollIcon = "".concat(assets).concat(endPoints.digitalAssets).concat(icons.paperlessIcon);
    if (!windowWidth.isLessThanMobile)
        return (_jsxs(_Fragment, { children: [_jsx(CustomStatementImage, { src: enrollIcon }), _jsx(Inset, {})] }));
    return null;
};
export default EnrollmentLogo;
